export const getPageRagardingCurrentDay = (currentDay, isMobile) => {
  const limit = isMobile ? 11 : 21
  return (currentDay / limit) ^ 0
}
